export function requestHeaders () {
    let token = localStorage.getItem('token')
    
    
    if (token) {
      return { Authorization: `Token ${token}` }
    } else {
      return {}
    }
  }